import { IStockBasicDetailsResponse } from "../pages/StockDetails/types";
import httpClient from "../utils/httpClient";

const SLUG_STOCK_DETAIL_PAGE = '-share-price';

export const getStockDetails = async (cocode: string, exchange?: string) => {
  try {
    const response = await httpClient.get(`/api/v1/stocks/${cocode}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStocksPriceChart = async (
  cocode: string,
  exchange: string,
  period: string
) => {
  return httpClient.get(
    `/api/v1/stocks/pricechart/${exchange}/${cocode}/${period}`
  );
};

export const getStocksOverview = async (cocode: string, exchange: string) => {
  try {
    return httpClient.get(`/api/v1/stocks/${cocode}/${exchange}`);
  } catch (error) {
    throw error;
  }
};

export const getStocksFinancials = async (
  cocode: string,
  reportType: string
) => {
  try {
    return httpClient.get(`/api/v1/financials/${cocode}/${reportType}`);
  } catch (error) {
    throw error;
  }
};

export const getStocksNews = async (cocode: string) => {
  try {
    return httpClient.get(`/api/v1/news/${cocode}`);
  } catch (error) {
    throw error;
  }
};

export const getStocksEvents = async (cocode: string) => {
  try {
    return httpClient.get(`/api/v1/meetings/agm/${cocode}`);
  } catch (error) {
    throw error;
  }
};

export const getStockCorporateActions = async (
  action: string,
  cocode: string
) => {
  try {
    return httpClient.get(`/api/v1/corporate-actions/${action}/${cocode}`);
  } catch (error) {
    throw error;
  }
};

export const getStockAbout = async (cocode: string) => {
  try {
    return httpClient.get(`api/v1/about/${cocode}`);
  } catch (error) {
    throw error;
  }
};


export const getStockBasicDetails = async (companyNameWithSlug: string): Promise<IStockBasicDetailsResponse> => {
  const lastIndex = companyNameWithSlug.lastIndexOf(SLUG_STOCK_DETAIL_PAGE);

  const companyNameWithoutSlug = lastIndex !== -1 
    ? companyNameWithSlug.substring(0, lastIndex) 
    : companyNameWithSlug;

  return httpClient.get(`/api/v1/stocks/${companyNameWithoutSlug}`);
};
